import { usePersonnalisation } from '../hooks/usePersonnalisation';

/**
 * Ruban « DEMO » en travers du coin supérieur droit.
 *
 * Tant que le site est en mode essai, chaque écran le dit : les chiffres
 * qu'on y voit sont d'entraînement, les factures qu'on y émet ne comptent
 * pas. Le ruban disparaît de lui-même au passage en production.
 *
 * La période offerte, elle, ne se met plus en travers de l'écran : elle a son
 * badge sous le nom de l'association — deux rubans superposés dans la pointe
 * du coin donnaient un résultat brouillon pour une information qui se lit
 * d'un regard.
 *
 * Le ruban prend la couleur d'accentuation du thème et ne capte aucun clic :
 * un bandeau qui masquerait un bouton du coin de l'écran serait pire que pas
 * de bandeau.
 */
export default function RubanDemo() {
  const perso = usePersonnalisation();

  if (perso?.modeEssai !== true) return null;

  return (
    <div
      aria-hidden="true"
      className="fixed top-0 right-0 z-[60] pointer-events-none overflow-hidden w-28 h-28 lg:w-36 lg:h-36"
    >
      <div
        className="absolute bg-primary-600 text-white text-center font-bold tracking-[0.3em] text-xs lg:text-sm py-1.5 shadow-md"
        style={{ width: '200%', transform: 'rotate(45deg)', top: '22%', right: '-50%' }}
      >
        DEMO
      </div>
    </div>
  );
}
